import { AxiosError } from 'axios';

export class JobMessageError extends Error {
  constructor(message = '') {
    super(message);
    this.name = 'JobMessageError';
  }
}

export class KJobEditError extends Error {
  constructor(message = '') {
    super(message);
    this.name = 'KJobEditError';
  }
}

export class KJobBookingError extends Error {
  reasons: string[];

  constructor(reasons: string[] = [], message = 'Job booking failed') {
    super(message);
    this.name = 'KJobBookingError';
    this.reasons = reasons;
  }
}

export class KJobEditCustomerError extends KJobEditError {
  constructor(message = '') {
    super(message);
    this.name = 'KJobEditCustomerError';
  }
}

export class KJobEditStopError extends KJobEditError {
  constructor(message = '') {
    super(message);
    this.name = 'KJobEditStopError';
  }
}

export class KJobEditServiceCodeError extends KJobEditError {
  constructor(message = '') {
    super(message);
    this.name = 'KJobEditServiceCodeError';
  }
}

export class KDialogError extends Error {
  constructor(message = '') {
    super(message);
    this.name = 'KDialogError';
  }
}

export class KHotkeyError extends Error {
  constructor(message = '') {
    super(message);
    this.name = 'KHotkeyError';
  }
}

export class SpreadsheetBooking400Error extends Error {
  constructor(message = '', options: { cause: AxiosError }) {
    super(message, options);
    this.name = 'SpreadsheetBooking400Error';
  }
}

// Allocation operations errors (allocate/deallocate/preallocate)
export class KJobEditAllocationError extends KJobEditError {
  constructor(message = '') {
    super(message);
    this.name = 'KJobEditAllocationError';
  }
}

export class KJobEditAllocationStateChangedError extends KJobEditAllocationError {
  constructor(message = '') {
    super(message);
    this.name = 'KJobEditAllocationStateChangedError';
  }
}

export class KJobEditAllocationLockedError extends KJobEditAllocationError {
  constructor(message = '') {
    super(message);
    this.name = 'KJobEditAllocationLockedError';
  }
}

export class KJobEditAllocationNotFoundError extends KJobEditAllocationError {
  constructor(message = '') {
    super(message);
    this.name = 'KJobEditAllocationNotFoundError';
  }
}

export class KJobEditAllocationUnlockedError extends KJobEditAllocationError {
  constructor(message = '') {
    super(message);
    this.name = 'KJobEditAllocationUnlockedError';
  }
}

// Lock/Unlock operations errors
export class KJobEditLockError extends KJobEditError {
  constructor(message = '') {
    super(message);
    this.name = 'KJobEditLockError';
  }
}

export class KJobEditLockedByOtherError extends KJobEditLockError {
  lockedBy?: string;

  constructor(message = '', lockedBy?: string) {
    super(message);
    this.name = 'KJobEditLockedByOtherError';
    this.lockedBy = lockedBy;
  }
}

export class KJobEditLockNotFoundError extends KJobEditLockError {
  constructor(message = '') {
    super(message);
    this.name = 'KJobEditLockNotFoundError';
  }
}

// Update operations errors (customer details, stops, products, services)
export class KJobEditUpdateLockedError extends KJobEditError {
  lockedBy?: string;

  constructor(message = '', lockedBy?: string) {
    super(message);
    this.name = 'KJobEditUpdateLockedError';
    this.lockedBy = lockedBy;
  }
}

export class KJobEditUpdateNotFoundError extends KJobEditError {
  constructor(message = '') {
    super(message);
    this.name = 'KJobEditUpdateNotFoundError';
  }
}

export class KJobEditUpdateUnlockedError extends KJobEditError {
  constructor(message = '') {
    super(message);
    this.name = 'KJobEditUpdateUnlockedError';
  }
}

export class KJobEditUpdateError extends KJobEditError {
  constructor(message = '') {
    super(message);
    this.name = 'KJobEditUpdateError';
  }
}

// Non-JobEdit error classes (from KTD-2242 fetchers refactor)
export class KLoginError extends Error {
  constructor(message = '') {
    super(message);
    this.name = 'KLoginError';
  }
}

export class KDetailedJobError extends Error {
  constructor(message = '') {
    super(message);
    this.name = 'KDetailedJobError';
  }
}
